import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { RoleRoute, type RolePageContext } from "@/auth/RoleRoute";
import { roleDestination } from "@/auth/roleEntry";
import "./RoleAccess.css";
export function RoleWorkspacePage() {
  return (
    <RoleRoute roles={["judge", "head_judge", "starter", "announcer"]}>
      {(context) => <Workspace context={context} />}
    </RoleRoute>
  );
}
function Workspace({ context }: { context: RolePageContext }) {
  const { session } = context;
  const [tablet, setTablet] = useState(() => window.matchMedia("(min-width:768px)").matches);
  const navigate = useNavigate();
  const [lastUsed] = useState(() => {
    try {
      const value = localStorage.getItem("scorio.role-workspace");
      return ["judge", "headjudge", "run"].includes(value ?? "") ? value : null;
    } catch {
      return null;
    }
  });
  useEffect(() => {
    const media = window.matchMedia("(min-width:768px)");
    const update = () => setTablet(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  if (!session) return <Navigate to="/dashboard" replace />;
  if (!session.roles.includes("head_judge"))
    return <Navigate to={roleDestination(session)} replace />;
  const base = `/competition/${encodeURIComponent(session.competitionId)}`;
  function choose(view: "judge" | "headjudge" | "run") {
    // Preference contains only a screen name, never credentials, roles or event details.
    try {
      localStorage.setItem("scorio.role-workspace", view);
    } catch {
      /* Preference is optional. */
    }
    navigate(`${base}/${view}?role=link`);
  }
  return (
    <main className="role-access">
      <header>
        <strong>Scorio</strong>
        <span>{session.competitionName}</span>
      </header>
      <section className="role-access-card">
        <h1>Choose your workspace</h1>
        <div className="role-workspace-list">
          <button className="role-workspace-choice" onClick={() => choose("judge")}>
            <strong>{session.seat ? `Score as J${session.seat}` : "Score as a judge"}</strong>
            <span>
              Enter scores for riders during their runs.{lastUsed === "judge" && " Last used."}
            </span>
          </button>
          <button
            className="role-workspace-choice"
            disabled={!tablet}
            onClick={() => choose("headjudge")}
          >
            <strong>Head judge console</strong>
            <span>
              {tablet
                ? `Review the panel and manage results.${lastUsed === "headjudge" ? " Last used." : ""}`
                : "Needs a tablet — use Run the day for phone corrections."}
            </span>
          </button>
          <button className="role-workspace-choice" onClick={() => choose("run")}>
            <strong>Run the day</strong>
            <span>
              Start heats and manage riders from your phone.{lastUsed === "run" && " Last used."}
            </span>
          </button>
        </div>
        <button className="role-access-leave" onClick={() => void context.onSignOut()}>
          Leave session
        </button>
      </section>
    </main>
  );
}
